import { useLocation } from "react-router-dom";
import CheckForInvalidLink from "../general/CheckForInvalidLink";
import AuthFetchBrokerResponse from "../general/AuthFetchBrokerResponse";
import GeneralAuthentication from "../general/GeneralAuthentication";
import { verifyBrokerAgainstProspect } from "../store/quotes";
import ReditMainPane from "../general/ReditMainPane";
import ReditLeftPane from "../general/ReditLeftPane";
import { useDispatch, useSelector } from "react-redux";
import { useLayoutEffect } from "react";
import {
  getCompareViewData,
  getPossibleApiStatusValueFromCompareView,
} from "../store/compareview";
// import ReditRightPane from "../general/ReditRightPane";

const Redit = (props) => {
  const { search } = useLocation();
  const dispatch = useDispatch();
  const queryParams = new URLSearchParams(window.location.search);

  const responseid = queryParams.get("id");
  const prospectid = queryParams.get("pid");
  const possibleApiStatusValue = useSelector(
    getPossibleApiStatusValueFromCompareView
  );
  useLayoutEffect(() => {
    dispatch(
      verifyBrokerAgainstProspect({
        prospectid: prospectid,
      })
    );
    dispatch(getCompareViewData({ prospectid, responseid }));
  }, [dispatch, prospectid, responseid]);
  let valid = false;
  if (responseid && responseid.length >= 24) valid = true;
  return (
    <GeneralAuthentication>
      <CheckForInvalidLink valid={valid}>
        <AuthFetchBrokerResponse
          possibleApiStatusValue={possibleApiStatusValue}
          responseid={responseid}
        >
          <ReditMainPane>
            {
              <ReditLeftPane
                prospectid={prospectid}
                responseid={responseid}
              ></ReditLeftPane>
            }
          </ReditMainPane>
        </AuthFetchBrokerResponse>
      </CheckForInvalidLink>
    </GeneralAuthentication>
  );
};

export default Redit;
